import React from 'react';

export const skipLabel = status => ({
  skipped_insufficient_funds: 'INSUFFICIENT FUNDS',
  skipped_premium_required: 'PREMIUM REQUIRED',
  skipped_missing_source_balance: 'SOURCE BALANCE UNAVAILABLE',
  skipped_invalid_source_percentage: 'INVALID SOURCE PERCENTAGE',
  skipped_no_copied_position: 'NO COPIED POSITION',
  skipped_insufficient_copied_position: 'COPIED POSITION TOO SMALL',
  skipped_unverified_copied_position: 'POSITION NEEDS REVIEW',
  skipped_below_precision: 'BELOW MINIMUM PRECISION',
  skipped_no_available_funds: 'NO AVAILABLE FUNDS',
  skipped_balance_changed: 'BALANCE CHANGED',
  skipped_balance_busy: 'BALANCE BUSY',
  skipped_copy_disabled: 'COPYING DISABLED',
  skipped_account_restricted: 'ACCOUNT RESTRICTED',
  skipped_invalid_source_notional: 'SOURCE VALUE MISMATCH',
  skipped_invalid_sizing_data: 'INVALID SIZING DATA',
  skipped_unknown_source: 'UNKNOWN COPY SOURCE',
  skipped_source_restricted: 'SOURCE ACCOUNT RESTRICTED',
  skipped_ambiguous_balance: 'BALANCE NEEDS REVIEW',
  skipped_invalid_source_trade: 'INVALID SOURCE TRADE',
  skipped_unverified_source: 'UNVERIFIED SOURCE',
  skipped_stale_source: 'SOURCE SNAPSHOT EXPIRED',
  skipped_future_source: 'INVALID SOURCE TIME',
  skipped_invalid_source_timestamp: 'SOURCE TIME UNAVAILABLE',
}[status] || 'COPY SKIPPED');

export const CopySizingDetails = ({ trade, prefix = 'trade' }) => {
  const isBot = String(trade.copied_from_id || '').endsWith('_bot');
  const legacy = isBot && !trade.sizing_mode;
  return <>
    {trade.sizing_mode === 'leader_percentage' && Number.isFinite(trade.allocation_percent) && <p className="text-sm text-cyan-300 mt-2" data-testid={`${prefix}-allocation-${trade.id}`}>
      Matched bot allocation: {trade.allocation_percent.toLocaleString(undefined, { maximumFractionDigits: 6 })}% of {trade.trade_type === 'sell' ? 'your position copied from this bot' : 'your available trading funds'}.
    </p>}
    {legacy && <p className="text-xs text-slate-400 mt-2" data-testid={`${prefix}-legacy-sizing-${trade.id}`}>Legacy record · Source balance was not captured. The recorded amount is not a new percentage-based allocation.</p>}
    {trade.execution_mode === 'legacy_internal' && <p className="text-xs text-slate-400 mt-1" data-testid={`${prefix}-internal-record-${trade.id}`}>Internal ledger record · Not a confirmed wallet transaction</p>}
  </>;
};